import React, { createContext, PropsWithChildren, useCallback, useRef, useState } from 'react'
import * as signalR from '@microsoft/signalr'
import { useConnectSignalR } from '../hooks/signalr/useSignalrConnect'
import { useAuth } from '../hooks'

interface SignalRContextType {
	connection: signalR.HubConnection | null
	isConnected: boolean
	connectionEpoch: number
	folderScopeId: string | null
	setFolderScopeId: (id: string | null) => void
	canUseFolderEvents: (id: string | null | undefined) => boolean
}

export const SignalRContext = createContext<SignalRContextType | null>(null)

export const SignalRProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const { isAuthenticated } = useAuth()
	const { connection, isConnected, connectionEpoch } = useConnectSignalR(isAuthenticated)
	const [folderScopeId, setFolderScope] = useState<string | null>(null)
	const scopeRef = useRef<string | null>(null)
	const connectionRef = useRef(connection)
	connectionRef.current = connection
	if (!isConnected) scopeRef.current = null
	const setFolderScopeId = useCallback((id: string | null) => {
		scopeRef.current = id
		setFolderScope(id)
	}, [])
	const canUseFolderEvents = useCallback((id: string | null | undefined) =>
		Boolean(id && scopeRef.current === id &&
			connectionRef.current?.state === signalR.HubConnectionState.Connected), [])

	return (
		<SignalRContext.Provider value={{ connection, isConnected, connectionEpoch, folderScopeId, setFolderScopeId, canUseFolderEvents }}>
			{children}
		</SignalRContext.Provider>
	)
}
